<div
  class="uc2-network-blade"
  [class.uc2-network-blade--open]="open()"
  [attr.aria-hidden]="!open()"
  tabindex="-1"
  (keydown.escape)="onClose()">
  <button
    [tabindex]="open() ? 0 : -1"
    (click)="onClose()"
    type="button"
    class="uc2-network-blade__backdrop"
    aria-label="Close network context"></button>

  <section
    id="uc2-network-context"
    [cdkTrapFocus]="open()"
    [cdkTrapFocusAutoCapture]="open()"
    [attr.aria-modal]="open() ? 'true' : null"
    [attr.role]="open() ? 'dialog' : null"
    aria-labelledby="uc2-network-blade-title"
    aria-describedby="uc2-network-blade-context"
    class="uc2-network-blade__panel">
    <header class="uc2-network-blade__header">
      <div>
        <h2 id="uc2-network-blade-title" class="uc2-network-blade__title">Network context</h2>
        <p id="uc2-network-blade-context" class="uc2-network-blade__context">Focused on {{ wellCode() }}</p>
      </div>
      <button
        [tabindex]="open() ? 0 : -1"
        (click)="onClose()"
        type="button"
        class="uc2-network-blade__close"
        aria-label="Close network context">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </header>

    <div class="uc2-network-blade__content">
      @if (open() && (wellCode() || assetCodes().length)) {
        <app-network-preview
          [asset]="wellCode()"
          [assetCodes]="assetCodes()"
          [expandable]="false"
          [fillHeight]="true"
          inlineUiMode="full" />
      }
    </div>
  </section>
</div>